export default __webpack_public_path__ + "static/media/IMG_0976.01d121f8.gif";